/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {SimpleDrawerExample, FullDrawerExample, FullscreenDrawerExample, LeftPlacementDrawerExample, DrawerCallbackExample, DrawerCustomTriggerExample, DrawerNoAnimationNoSpacing} from 'Docs/uilib/components/drawer/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Basic Drawer"
    }), "\n", _jsx(SimpleDrawerExample, {}), "\n", _jsx(_components.h3, {
      children: "Basic Drawer left placement"
    }), "\n", _jsx(LeftPlacementDrawerExample, {}), "\n", _jsx(_components.h3, {
      children: "Basic Drawer in fullscreen"
    }), "\n", _jsx(FullscreenDrawerExample, {}), "\n", _jsx(_components.h3, {
      children: "Drawer with custom content"
    }), "\n", _jsx(FullDrawerExample, {}), "\n", _jsx(_components.h3, {
      children: "Customize trigger button"
    }), "\n", _jsx(DrawerCustomTriggerExample, {}), "\n", _jsx(_components.h3, {
      children: "Close Drawer by callback method"
    }), "\n", _jsx(DrawerCallbackExample, {}), "\n", _jsx(_components.h3, {
      children: "Remove animation and spacing"
    }), "\n", _jsx(DrawerNoAnimationNoSpacing, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
